import React from 'react';
import './InteriorDesign.css';
import useScrollToTop from '../components/useScrollToTop.js';
import ReusableLanding from '../components/ReusableLanding.js';
import image2 from '../img/exterior.webp';
import FAQ from '../components/FAQ.js';
import officeInteriorFAQData from '../components/officeInteriorFAQData.js';
import InquiryForm from '../components/InquiryForm.js';
import WhyChooseUs from '../components/WhyChooseUs.js';
//import officeImg1 from '../img/office_img_3.avif';
import officeImg2 from '../img/office_img_.avif';
import officeImg3 from '../img/office_img_4.avif';
//import officeImg4 from '../img/office_img_2.avif';
import officeImg5 from '../img/office_img_1.avif';
//import officeImg6 from '../img/office_ortho.avif';
import officeImg7 from '../img/office_ortho_2.avif';
import officeImg8 from '../img/office_ortho_3.avif';

const OfficeInteriorDesign = () => {
  useScrollToTop();
  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Office Interior Design"
        description="A well-designed office space can significantly impact productivity, employee morale, and company image. At Housekaar, we create office interior designs that are both functional and inspiring."
      />
      <div className="interior-design-page">
        <section className="office-section office-room"> {/* Using featured-room for consistent styling */}
          <div className="text-content">
            <h2>Workspaces and Collaboration Areas</h2>
            <p>
              We design workspaces that promote efficiency and collaboration. Our open-plan layouts, ergonomic furniture, and advanced technology integration create a dynamic and productive work environment.
            </p>
            <ul>
              <li>Open-plan and private office layouts</li>
              <li>Ergonomic furniture and workstation design</li>
              <li>Collaboration areas and meeting rooms</li>
              <li>Technology integration and cabling solutions</li>
            </ul>
          </div>
          <div className="office-image-container">
            <img src={officeImg7} alt="Reception and Client Areas" className="featured-image" loading="lazy"/>
          </div>
        </section>

        <section className="office-section office-room">
          <div className="text-content">
            <h2>Reception and Client Areas</h2>
            <p>
              The reception area is the first impression your clients have of your company, and we design spaces that are both welcoming and professional. Our client area designs create a comfortable and impressive environment for meetings and presentations.
            </p>
            <ul>
              <li>Reception desk and seating design</li>
              <li>Client meeting rooms and presentation areas</li>
              <li>Branding and signage integration</li>
              <li>Acoustic and soundproofing solutions</li>
            </ul>
          </div>
          <div className="office-image-container">
            <img src={officeImg2} alt="Reception and Client Areas" className="featured-image" loading="lazy"/>
          </div>
        </section>

        <section className="office-section office-room">
          <div className="text-content">
            <h2>Break Rooms and Amenities</h2>
            <p>
              We understand the importance of employee well-being, and we design break rooms and amenities that provide a relaxing and rejuvenating space for employees. Our designs focus on creating a balance between functionality and comfort.
            </p>
            <ul>
              <li>Kitchenette and dining areas</li>
              <li>Lounge and relaxation spaces</li>
              <li>Recreation and fitness areas</li>
              <li>Storage and organization solutions</li>
            </ul>
          </div>
          <div className="office-image-container">
            <img src={officeImg3} alt="Break Rooms and Amenities" className="featured-image" loading="lazy"/>
          </div>
        </section>

        <section className="office-section office-room">
          <div className="text-content">
            <h2>Sustainability and Innovation</h2>
            <p>
              We are committed to creating sustainable and innovative office designs that reduce environmental impact and promote employee well-being. From energy-efficient lighting and HVAC systems to eco-friendly materials and finishes, we incorporate sustainable practices into every aspect of our designs.
            </p>
          </div>
          <div className="office-image-container">
            <img src={officeImg8} alt="Sustainability and Innovation" className="featured-image" loading="lazy"/>
          </div>
        </section>

        <section className="office-section"> {/* Using a regular office-section for the grid of one image */}
          <h2>Additional Workspace Ideas</h2> {/* Added a heading for the single image */}
          <div className="room-grid"> {/* Using room-grid to display the single image nicely */}
            <img src={officeImg5} alt="Additional Workspace Idea" loading="lazy"/>
          </div>
        </section>
      </div>
      <WhyChooseUs />
      <InquiryForm />
      <FAQ faqData={officeInteriorFAQData} />
    </>
  );
};

export default OfficeInteriorDesign;